import styled from 'styled-components';
import { baseVariables, toRem } from '../../styles';

const { mediaQuery, spacers } = baseVariables;

const spacer8 = spacers?.spacers?.[2] ?? toRem(8);
const spacer16 = spacers?.spacers?.[3] ?? toRem(16);
const spacer24 = spacers?.spacers?.[4] ?? toRem(24);
const spacer32 = spacers?.spacers?.[5] ?? toRem(32);

export const Wrapper = styled.div`
  width: 100%;
  max-width: 100%;
  background-color: var(--t-brand-bg-color);
  color: var(--t-brand-fg-color);
  padding-block: ${spacer24};
  padding-inline: ${spacer16};

  @media ${mediaQuery.md} {
    padding-block: ${spacer32};
    padding-inline: 0;
  }
`;

export const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-inline: auto;

  @media ${mediaQuery.md} {
    &.container {
      max-width: ${toRem(720)};
    }
  }

  @media ${mediaQuery.lg} {
    &.container {
      max-width: ${toRem(1140)};
    }
  }
`;

export const HeaderWrapper = styled.div`
  [data-component-name='a-web-ui-kit-AHeader'] {
    padding-block-end: ${spacer8};
  }
`;

export const CardsGrid = styled.div<{ $desktopColumns: number; $isAuthorMode?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${spacer16};
  width: 100%;
  padding-block-end: ${spacer24};
  align-items: stretch;

  @media ${mediaQuery.md} {
    gap: ${spacer24};
  }

  @media ${mediaQuery.lg} {
    display: grid;
    grid-template-columns: ${({ $desktopColumns }) => `repeat(${$desktopColumns}, minmax(0, 1fr))`};
    gap: ${spacer24};
    align-items: stretch;
  }

  /*
   * MSlot wraps cards in extra divs. display: contents lets those cards
   * participate in this grid. Author mode keeps the wrappers so the
   * AEM parsys drop target stays a real box.
   */
  ${({ $isAuthorMode }) =>
    !$isAuthorMode &&
    `
    .m-slot,
    .m-slot > div {
      display: contents;
    }
  `}

  & > *,
  .m-slot > div > * {
    box-sizing: border-box;
    min-width: 0;
    width: 100%;
  }

  /*
   * Desktop-only equal-height stretch. In a 2- or 3-column row, every card
   * fills the tallest card in that row. max-*height overrides are needed to
   * defeat any per-card max-block-size clamp (e.g. OCardMiniImage's 100px)
   * so a shorter card can grow to match its taller row-mate.
   */
  @media ${mediaQuery.lg} {
    & > *,
    .m-slot > div,
    .m-slot > div > * {
      align-self: stretch;
      height: 100%;
      block-size: 100%;
      max-height: none;
      max-block-size: none;
    }

    a {
      width: 100% !important;
      height: 100% !important;
    }
  }
`;
